import { Address } from './address'

export class Organization {
    private _id?: string | undefined
    private _name?: string | undefined
    private _act_start_date?: string | undefined
    private _act_end_date?: string | undefined
    private _municipality?: string | undefined
    private _uf_id?: string | undefined
    private _email?: string | undefined
    private _phone?: string | undefined
    private _address?: Address | undefined
    private _responsible?: string | undefined
    private _responsible_sector?: string | undefined
    private _notes?: string | undefined
    private _logo?: string | undefined

    get id(): string | undefined {
        return this._id
    }

    set id(value: string | undefined) {
        this._id = value
    }

    get name(): string | undefined {
        return this._name
    }

    set name(value: string | undefined) {
        this._name = value
    }

    get act_start_date(): string | undefined {
        return this._act_start_date
    }

    set act_start_date(value: string | undefined) {
        this._act_start_date = value
    }

    get act_end_date(): string | undefined {
        return this._act_end_date
    }

    set act_end_date(value: string | undefined) {
        this._act_end_date = value
    }

    get municipality(): string | undefined {
        return this._municipality
    }

    set municipality(value: string | undefined) {
        this._municipality = value
    }

    get uf_id(): string | undefined {
        return this._uf_id
    }

    set uf_id(value: string | undefined) {
        this._uf_id = value
    }

    get email(): string | undefined {
        return this._email
    }

    set email(value: string | undefined) {
        this._email = value
    }

    get phone(): string | undefined {
        return this._phone
    }

    set phone(value: string | undefined) {
        this._phone = value
    }

    get address(): Address | undefined {
        return this._address
    }

    set address(value: Address | undefined) {
        this._address = value
    }

    get responsible(): string | undefined {
        return this._responsible
    }

    set responsible(value: string | undefined) {
        this._responsible = value
    }

    get responsible_sector(): string | undefined {
        return this._responsible_sector
    }

    set responsible_sector(value: string | undefined) {
        this._responsible_sector = value
    }

    get notes(): string | undefined {
        return this._notes
    }

    set notes(value: string | undefined) {
        this._notes = value
    }

    get logo(): string | undefined {
        return this._logo
    }

    set logo(value: string | undefined) {
        this._logo = value
    }

    public fromJSON(json: any): Organization {
        if (!json) return this

        if (json.id !== undefined) this.id = json.id
        if (json.name !== undefined) this.name = json.name
        if (json.act_start_date !== undefined) this.act_start_date = json.act_start_date
        if (json.act_end_date !== undefined) this.act_end_date = json.act_end_date
        if (json.municipality !== undefined) this.municipality = json.municipality
        if (json.uf_id !== undefined) this.uf_id = json.uf_id
        if (json.email !== undefined) this.email = json.email
        if (json.phone !== undefined) this.phone = json.phone
        if (json.address !== undefined)
            this.address = new Address().fromJSON(json.address)
        if (json.responsible !== undefined) this.responsible = json.responsible
        if (json.responsible_sector !== undefined) this.responsible_sector = json.responsible_sector
        if (json.notes !== undefined) this.notes = json.notes
        if (json.logo !== undefined) this.logo = json.logo

        return this
    }

    public toJSON(): any {
        return {
            id: this.id || undefined,
            name: this.name || undefined,
            act_start_date: this.act_start_date || undefined,
            act_end_date: this.act_end_date || undefined,
            municipality: this.municipality || undefined,
            uf_id: this.uf_id || undefined,
            email: this.email || undefined,
            phone: this.phone || undefined,
            address: this.address?.toJSON() || undefined,
            responsible: this.responsible || undefined,
            responsible_sector: this.responsible_sector || undefined,
            notes: this.notes || undefined,
            logo: this.logo || undefined,
        }
    }
}
